import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessagesComponent } from '../messages/messages.component';
import { PaymentService } from '../services/payment.service';
import { TimetableService } from '../services/timetable.service';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-view-timetable',
  templateUrl: './view-timetable.component.html',
  styleUrls: ['./view-timetable.component.css']
})
export class ViewTimetableComponent implements OnInit {
  public timetable = [];
  public days = [];
  public periods = [];
  public venues = [];
  public display = [];
  public displayTimetable = [];
  public paymentEligible:any = {control: true};

  constructor(private _timetableService : TimetableService, public _paymentService: PaymentService, public dialog: MatDialog, public log: LogService) { }

  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "View Timetable",
      details: `Accessed View Timetable`,
    }).subscribe(data => { });
    this._paymentService.getPaymentEligibility({key: 'timetable'}).subscribe(data => {
      this.paymentEligible = data;
      if(this.paymentEligible.control == false){
        if(!this.paymentEligible.control){
          this.dialog.open(MessagesComponent, {
              data: {for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to view results`}
          })
        }
        return;
      }else{
        this.getDays();
      }
    }); 
    //structure an array from days and time to be displayed in the view
    // this.getDays();
    
  }

  getDays(){
    
    this._timetableService.getPeriods().subscribe(data => {
      this.periods = data;

      //get periods here
      this._timetableService.getDays().subscribe(data => {
        this.days = data;

        this._timetableService.getTimeTable().subscribe(data => {
          this.timetable = data;

          for(let p in this.periods){
            this.periods[p].days = [];
            for(let d in this.days){
              //filter set courses at this particular period
               let timetable = this.timetable.filter(t =>  t.period_id == this.periods[p].period_id
                                    && t.day_id == this.days[d].day_id
                                )
                                //console.log(timetable);
              this.periods[p].days.push(
                {
                  day: this.days[d].day,
                  course_title: (timetable.length == 0) ? '' : timetable[0].title,
                  venue: (timetable.length == 0) ? '' : '('+timetable[0].name+')'
                }
              );
            }
            this.display.push(this.periods[p]);
    
          }
          //console.log(this.display);

        })
      })

    })
  }



  getVenues(){
    this._timetableService.getVenues().subscribe(data => {
      this.venues = data;
    })
  }



}
